import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import ErrorBoundary from './ErrorBoundary';
import './index.scss';
import App from './App';

import configureStore from './store';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './authConfig';
import { MsalProvider } from '@azure/msal-react';
const msalInstance = new PublicClientApplication(msalConfig);
const store = configureStore();

const Root = () => (
  <Provider store={store}>
    <MsalProvider instance={msalInstance}>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </MsalProvider>
  </Provider>
);

ReactDOM.render(<Root />, document.getElementById('root'));
